export const useDashbaordSectionData = () => {
  const getCardData = (stats, dataPath) => {
    const pathArray = dataPath.split(".");
    let data = stats;

    for (const key of pathArray) {
      data = data?.[key];
      if (!data) break;
    }

    return data || { count: 0, percentageChange: 0, description: "" };
  };

  const getCardDataFromApiPath = (dashboardData, dataPath) => {
    if (!dashboardData?.apiData) {
      return { count: 0, percentageChange: 0, description: "" };
    }

    return getCardData(dashboardData.apiData, dataPath);
  };

  return {
    getCardDataFromApiPath,
  };
};
